import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { undo, redo } from 'prosemirror-history';
import { baseKeymap, toggleMark, chainCommands } from 'prosemirror-commands';
import { findParentNodeOfType, findParentNodeClosestToPos } from 'prosemirror-utils';
import { wrapInList, splitListItem, liftListItem, sinkListItem } from 'prosemirror-schema-list';
const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;

/**
 * @description Builds key kandlers inside editor
 * @param {Object} schema - Schema of the editor
 */

const Backspace = (nodeType, state, dispatch) => {
  const itemType = state.schema.nodes[nodeType];
  const ref = state.selection;
  const $from = ref.$from;
  const currentNode = findParentNodeOfType(state.schema.nodes[nodeType])(state.selection);
  if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.node.type) == itemType && (currentNode === null || currentNode === void 0 ? void 0 : currentNode.node.childCount) < 2) {
    const parentnode = findParentNodeClosestToPos($from, node => node.type === state.schema.nodes.bullet_list || node.type === state.schema.nodes.ordered_list || node.type === state.schema.nodes.todo_list);
    if ((parentnode === null || parentnode === void 0 ? void 0 : parentnode.node.childCount) !== 1 && (parentnode === null || parentnode === void 0 ? void 0 : parentnode.node.firstChild) !== (currentNode === null || currentNode === void 0 ? void 0 : currentNode.node)) {
      return false;
    }
    if (ref.$head.parentOffset !== 0) {
      return false;
    }
    return liftListItem(state.schema.nodes[nodeType])(state, dispatch);
  }
  return false;
};
export const buildKeymap = schema => {
  const keyMap = _objectSpread(_objectSpread({}, baseKeymap), {}, {
    'Mod-z': undo,
    'Shift-Mod-z': redo
  });
  if (!mac) {
    keyMap['Mod-y'] = redo;
  }
  if (schema.marks.underline) {
    keyMap['Mod-u'] = toggleMark(schema.marks.underline);
    keyMap['Mod-U'] = toggleMark(schema.marks.underline);
  }
  if (schema.marks.strong) {
    keyMap['Mod-b'] = toggleMark(schema.marks.strong);
    keyMap['Mod-B'] = toggleMark(schema.marks.strong);
  }
  if (schema.marks.em) {
    keyMap['Mod-i'] = toggleMark(schema.marks.em);
    keyMap['Mod-I'] = toggleMark(schema.marks.em);
  }
  if (schema.nodes.bullet_list) {
    keyMap['Shift-Ctrl-8'] = wrapInList(schema.nodes.bullet_list);
  }
  if (schema.nodes.ordered_list) {
    keyMap['Shift-Ctrl-9'] = wrapInList(schema.nodes.ordered_list);
  }
  if (schema.nodes.list_item && schema.nodes.todo_list_item) {
    keyMap.Enter = chainCommands(splitListItem(schema.nodes.list_item), splitListItem(schema.nodes.todo_list_item, {
      done: false
    }), liftListItem(schema.nodes.todo_list_item, {
      done: false
    }), baseKeymap.Enter);
    keyMap['Mod-['] = chainCommands(liftListItem(schema.nodes.list_item), liftListItem(schema.nodes.todo_list_item));
    keyMap['Mod-]'] = chainCommands(sinkListItem(schema.nodes.list_item), sinkListItem(schema.nodes.todo_list_item));
    keyMap['Backspace'] = chainCommands((state, dispatch) => Backspace('list_item', state, dispatch), (state, dispatch) => Backspace('todo_list_item', state, dispatch), baseKeymap.Backspace);
  } else {
    if (schema.nodes.list_item) {
      keyMap.Enter = chainCommands(splitListItem(schema.nodes.list_item), baseKeymap.Enter);
      keyMap['Mod-['] = liftListItem(schema.nodes.list_item);
      keyMap['Mod-]'] = sinkListItem(schema.nodes.list_item);
      keyMap['Backspace'] = chainCommands((state, dispatch) => Backspace('list_item', state, dispatch), baseKeymap.Backspace);
    }
    if (schema.nodes.todo_list_item) {
      keyMap.Enter = chainCommands(splitListItem(schema.nodes.todo_list_item, {
        done: false
      }), liftListItem(schema.nodes.todo_list_item, {
        done: false
      }), baseKeymap.Enter);
      keyMap['Mod-['] = liftListItem(schema.nodes.todo_list_item);
      keyMap['Mod-]'] = sinkListItem(schema.nodes.list_item);
      keyMap['Backspace'] = chainCommands((state, dispatch) => Backspace('todo_list_item', state, dispatch), baseKeymap.Backspace);
    }
  }
  return keyMap;
};